/**
 * @fileoverview Contexto responsável por armazenar a mensagem atualmente em resposta no ticket.
 */

import React, { useState, createContext } from "react";

const ReplyMessageContext = createContext();

const ReplyMessageProvider = ({ children }) => {
	const [replyingMessage, setReplyingMessage] = useState(null);
	const [optimisticDispatch, setOptimisticDispatch] = useState(null);

	return (
		<ReplyMessageContext.Provider
			value={{
				replyingMessage,
				setReplyingMessage,
				optimisticDispatch,
				setOptimisticDispatch
			}}
		>
			{children}
		</ReplyMessageContext.Provider>
	);
};

export { ReplyMessageContext, ReplyMessageProvider };
